import { formatInternational } from 'lib-shared-phone-numbers';
import type { ConversationNodeForward } from 'lib-shared-types-api';

type Props = {
  node: ConversationNodeForward;
};

export function RoutedThroughForward({ node }: Props): JSX.Element {
  return (
    <>
      Forward · To{' '}
      <strong>
        {formatInternational(node.phone_number) || node.phone_number}
      </strong>{' '}
      ({node.call_pattern})
    </>
  );
}
